import axios from 'axios';
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';

export async function fetchTrees() {
  try {
    const treesResponse = await axios.get('trees.json');
    return digestTreesFromJson(treesResponse.data);
  } catch (error) {
    console.error(error);
    return {};
  }
}

export function digestTreesFromJson(treesJson) {

  // sort trees by their number
  const sortedTrees = sortBy(treesJson, tree => Number(tree.number));

  let treesCollection = {};
  if (treesJson.length <= 0) return treesCollection;

  return sortedTrees.reduce((treesCollection, treeJson) => {

    const treeId = `${treeJson.side}${treeJson.number}`;
    const treeSlug = `${String(treeJson.side).toLowerCase()}-${treeJson.number}`;

    const tree = {
      id: treeId,
      key: treeSlug,
      number: get(treeJson, 'number'),
      side: get(treeJson, 'side'),
      lat: get(treeJson, 'lat'),
      lon: get(treeJson, 'lon'),
      plaque: get(treeJson, 'plaque'),
      fullName: get(treeJson, 'full_name'),
      firstName: get(treeJson, 'first_name'),
      middleName: get(treeJson, 'middle_name'),
      lastName: get(treeJson, 'last_name'),
      rank: get(treeJson, 'rank'),
      roll: get(treeJson, 'roll'),
      serviceNumber: get(treeJson, 'service_number'),
      age: get(treeJson, 'age'),
      fate: get(treeJson, 'fate'),
    };

    treesCollection[treeSlug] = tree;

    return treesCollection;
  }, treesCollection);
}
